export default __webpack_public_path__ + "static/media/icon02.dde5eaec.svg";